<app-page-header title="Edit Expected Bill"></app-page-header>
<div class="row">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-header" *ngIf="expected_bill_model.id">Edit Expected Bill</div>
            <div class="card-header" *ngIf="!expected_bill_model.id">Create Expected Bill</div>
            <div class="card-body">
                <form [formGroup]="expected_bill_form" (ngSubmit)="submit($event)">
                    <nexus-form-row row_label="Utilities Start Date">
                        <kendo-datepicker class="form-control" [format]="'MM/dd/yyyy'"
                            formControlName="utilities_start_date"></kendo-datepicker>
                    </nexus-form-row>
                </form>
                <nexus-form-row>                    
                    <button kendoButton [primary]="true" [icon]="'check'" type="button" [disabled]="!expected_bill_form.valid"
                        (click)="submit($event)">Submit</button>
                </nexus-form-row>
                <nexus-form-result [model]="expected_bill_result"></nexus-form-result>
            </div>
        </div>
    </div>
    <div class="col-lg-6">

    </div>
</div>
<p class="mt-3">
    <a [routerLink]="['/billing','expected-bills']">Back</a>
</p>
